export const checkEqualityOfObjects = (object1, object2, propsToCheck) => {
    let check = true;
    propsToCheck.map( prop => {
        if(object1[prop] !== object2[prop]){
            check = false
        }
        return prop;
    })
    return check;
}

export const convertSize = (width) => {
    switch (width) {
        case 'xs':
            return 'min(300px, calc(100vw - 48px))'
        case 'sm':
            return 'min(500px, calc(100vw - 64px))'
        case 'md':
            return 'min(800px, calc(100vw - 64px))'
        case 'lg':
            return 'min(960px, calc(100vw - 64px))'
        default:
            return 'min(1100px, calc(100vw - 64px))'
    }
}
